module.exports = __webpack_public_path__ + "static/img/lundbeck-logo-1280x1280.5745a219.png";